<template>
  <nav class="navbar fixed-top">
    <div class="container-fluid">
      <div class="navbar-header">
        <a class="navbar-brand p-0" href="/">
          <img
            src="@/assets/images/titulo.png"
            alt="Medical Records"
            class="navbar-logo"
          />
        </a>
      </div>
      <button class="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar">
        <i class="material-icons">menu</i>
      </button>
      <div class="offcanvas offcanvas-end" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
        <div class="offcanvas-header">
          <div class="user-info">
            <span class="user-name">{{ usuario }}</span>
            <span class="user-role">{{ perfil }}</span>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div class="offcanvas-body">
          <ul class="navbar-nav">
            <router-link class="nav-link" to="/actualizarclave">Cambio de Clave</router-link>
            <li class="nav-link clickable" @click="logout('changeUser')">Cambio de Usuario</li>
<!--
            <router-link class="nav-link" to="/configuracion2fa">Configuración 2FA</router-link>
-->
          </ul>
        </div>

        <div class="offcanvas-body">
          <ul class="navbar-nav">
            <router-link class="nav-link" to="/consultacobertura">Consulta Cobertura</router-link>
            <router-link class="nav-link" to="/vademecum">Vademecum</router-link>
            <router-link class="nav-link" to="/calculadora">Calculadora</router-link> 

            <router-link class="nav-link" to="/imc">Cálculo de IMC</router-link>

          </ul>
        </div>

        <div class="nav-item logout-button">
          <button @click="logout('logout')">
            <i class="material-icons">power_settings_new</i>
            Cerrar Sesión
          </button>
        </div>

      </div>
    </div>
  </nav>
</template>
  
<script>
export default {
  name: 'Navbar',
  props: {
    usuario: String,
    perfil: String,
    modulo: Number
  },
  methods: {
    logout(action) {
      this.$emit('logout', action);
    }
  }
};
</script>
<style src="@/assets/css/navbar.css" scoped></style>
<style scoped>
.navbar-logo {
  height: 35px;
  width: auto;
  object-fit: contain;
}

.clickable {
  cursor: pointer;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 12px;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 4px;
}

.user-name {
  font-size: 1rem;
  font-weight: 600;
  color: #0d6efd;
}

.user-role {
  font-size: 0.8rem;
  color: #6b7280;
  text-transform: capitalize;
}
</style>